import React, {useEffect} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
// import RegistrationForm from '../components/common/RegistrationForm'


import jonathanMifsudPhoto from '../../assets/images/team/jonathan-mifsud.jpg';
import jeremyMifsudPhoto from '../../assets/images/team/jeremy-mifsud.jpg';

const teamMembers = [
  {
    name: "Jonathan Mifsud",
    photo: jonathanMifsudPhoto,
    role: "Co-Founder & CTO",
    linkedIn: "https://www.linkedin.com/in/jonmifsud/",
    bio: "Jonathan and his tech team are always looking at ways to make payroll simpler, faster and error free. He set his sights on Buddy being the #1 payroll solution."
  },
  {
    name: "Jeremy Mifsud",
    photo: jeremyMifsudPhoto,
    role: "Head of Customer Experience",
    linkedIn: "https://www.linkedin.com/in/jeremy-mifsud/",
    bio: "Jeremy's #1 priority is your happiness. The customer experience team is available to help via chat and phone to ensure you have a great experience."
  },
]


function Team({

}) {


  return null;

  /* Team block preserved for later
  return (

    <div id="team" className="bg-white">
      <div className="mx-auto py-12 px-4 max-w-screen-xl sm:px-6 lg:px-8 lg:py-24">
        
          <div className="spface-y-5 sm:space-y-4 mb-8">
            <h2 className="text-3xl leading-9 font-extrabold tracking-tight sm:text-4xl">Our Team</h2>
            <p className="text-xl leading-7 text-gray-500">A seamless payroll experience with Buddy wouldn't be possible without these people.</p>
          </div>
          <div>
            <ul className="space-y-12 sm:grid sm:grid-cols-4 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:gap-x-8">
              {
                teamMembers.map(teamMember => (
                  <li>
                    <div className="space-y-4">
                      <div className="aspect-w-3 aspect-h-2">
                        <img className="absolute object-cover h-full w-full shadow-lg rounded-lg" src={teamMember.photo} alt=""/>
                      </div>
                      <div className="text-lg leading-6 font-medium space-y-1">
                        <h4>{teamMember.name}</h4>
                        <p className="text-orange-600">{teamMember.role}</p>
                      </div>
                      <div className="text-lg leading-7">
                        <p className="text-gray-500">{teamMember.bio}</p>
                      </div>

                      <ul className="flex space-x-5">
                        <li>
                          <a href={teamMember.linkedIn} target="_blank" className="text-gray-400 hover:text-gray-500 transition ease-in-out duration-150">
                            <span className="sr-only">LinkedIn</span>
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                ))
              }
            </ul>
          </div>
      </div>
    </div>


    
    
  );
  */
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Team) 
